<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-pencil"></i> Sentences</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Text:</label>
                  <div class="control">
                    <span>{{item.text}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Schools:</label>
                    <div class="control" v-if="!item.schools">All schools</div>
                    <div v-else class="control" v-for="school in item.schools">
                        <p>{{school.name}}</p>
                    </div>
                </div>
            </div>

            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'premade-comments-show',
  components: {},
  data() {
        return {
            item: {},
        }
  },
  created(){  
    this.getPremadeComment(this.$route.params.id);
  },
  methods: {
      getPremadeComment(id){
        this.premadeCommentRepo.get(id).then(response => {
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-comments/Show.vue